import React from 'react';
import './NameInput.css';

interface NameInputProps {
  id: string;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}

const NameInput: React.FC<NameInputProps> = ({ id, value, placeholder, onChange }) => {
  return (
    <div className="intro-hero-form">
      <input
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="intro-hero-input"
      />
    </div>
  );
};

export default NameInput;
